import { render, staticRenderFns } from "./TheEmbed.vue?vue&type=template&id=cff0c35a&scoped=true"
import script from "./TheEmbed.vue?vue&type=script&lang=js"
export * from "./TheEmbed.vue?vue&type=script&lang=js"
import style0 from "./TheEmbed.vue?vue&type=style&index=0&id=cff0c35a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff0c35a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cff0c35a')) {
      api.createRecord('cff0c35a', component.options)
    } else {
      api.reload('cff0c35a', component.options)
    }
    module.hot.accept("./TheEmbed.vue?vue&type=template&id=cff0c35a&scoped=true", function () {
      api.rerender('cff0c35a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/TheEmbed.vue"
export default component.exports